(function () {
  var MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CLOSE_DURATION_MS = 320;

  document.querySelectorAll('[data-fragrance-dropdown]').forEach(function (dropdown) {
    var trigger = dropdown.querySelector('[data-fragrance-dropdown-trigger]');
    var panel = dropdown.querySelector('[data-fragrance-dropdown-panel]');
    var toggle = trigger && trigger.querySelector('.fragrance-dropdown__toggle');
    var closeTimer = null;

    if (!trigger || !panel) return;

    function setToggle(isOpen) {
      if (toggle) toggle.textContent = isOpen ? '\u2212' : '+';
    }

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function setOpen(isOpen) {
      clearCloseTimer();
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      setToggle(isOpen);

      if (isOpen) {
        panel.hidden = false;
        dropdown.offsetHeight;
        requestAnimationFrame(function () {
          dropdown.classList.add('is-open');
        });
        return;
      }

      dropdown.classList.remove('is-open');

      if (MOTION_QUERY.matches) {
        panel.hidden = true;
        return;
      }

      closeTimer = setTimeout(function () {
        if (!dropdown.classList.contains('is-open')) {
          panel.hidden = true;
        }
        closeTimer = null;
      }, CLOSE_DURATION_MS);
    }

    trigger.addEventListener('click', function () {
      setOpen(!dropdown.classList.contains('is-open'));
    });

    document.addEventListener('click', function (event) {
      if (!dropdown.contains(event.target)) {
        setOpen(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    });
  });
})();
